import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MtnaAuthFacade } from '@mtna/core-user-angular';
import { DataAccessPolicy, instanceofDataUsageAgreement } from '@mtna/pojo-consumer-ts';
import { AccessRequirementFacade, MtnaAccessRequirementComponent } from '@mtna/web-security-angular';
import { AccessRequirement } from '@mtna/web-security-ts';
import { instanceOfRdsUserProfile } from '@rds/rds-base-ts';
import { DataAccessPolicyRequirement, instanceofDataAccessPolicyRequirement } from '@rds/shared-api';
import { RdsAuthFacade } from '@rds/shared-state-auth';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'rds-c-access-requirement-data-access-policy',
  templateUrl: './access-requirement-data-access-policy.component.html',
  styleUrls: ['./access-requirement-data-access-policy.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})

// eslint-disable-next-line @angular-eslint/component-class-suffix
export class RdsDataAccessPolicyAccessRequirement extends MtnaAccessRequirementComponent implements OnInit {
  @Input()
  get accessRequirement(): AccessRequirement | undefined {
    return this._dataAccessPolicyRequirement;
  }

  set accessRequirement(accessRequirement: AccessRequirement | undefined) {
    if (instanceofDataAccessPolicyRequirement(accessRequirement)) {
      this._dataAccessPolicyRequirement = accessRequirement;
      this.rdsAuthFacade.getDataAccessPolicy(this._dataAccessPolicyRequirement.policyUri);
    }
  }

  /*
   * I am not sure why I have to do this here. I tried to implement the typical destroy mixin that we typically use
   * (which does the exact same thing) but that was not working. I am not sure if it is due to this being used in a
   * dialog or something along those lines, but for now this works.
   */
  private unsubscribe$: Subject<void> = new Subject<void>();
  private _dataAccessPolicyRequirement: DataAccessPolicyRequirement | undefined;

  dataAccessPolicy$ = this.rdsAuthFacade.dataAccessPolicy$.pipe(
    map((dataAccessPolicy) => {
      this.dataAccessPolicy = dataAccessPolicy;
      return dataAccessPolicy;
    })
  );
  dataAccessPolicy: DataAccessPolicy | undefined;
  form: FormGroup = this.fb.group({});

  constructor(
    private rdsAuthFacade: RdsAuthFacade,
    protected authFacade: MtnaAuthFacade,
    private fb: FormBuilder,
    protected accessRequirementFacade: AccessRequirementFacade
  ) {
    super(accessRequirementFacade);
    this.monitorUserProfile();
  }

  ngOnInit() {
    this.form = this.fb.group({
      terms: [Validators.requiredTrue],
    });
  }

  checkBoxValueChange(change: MatCheckboxChange) {
    if (instanceofDataUsageAgreement(this.dataAccessPolicy)) {
      this.requirementValid.emit(change.checked);
    }
  }

  finalizeAccessRequirement(): void {
    if (instanceofDataUsageAgreement(this.dataAccessPolicy)) {
      this.rdsAuthFacade.signDataUsageAgreement(this.dataAccessPolicy.uri);
    }
  }

  private monitorUserProfile(): void {
    this.authFacade.user$.pipe(takeUntil(this.unsubscribe$)).subscribe((user) => {
      if (this._dataAccessPolicyRequirement && user?.userProfile) {
        const userProfile = user.userProfile;
        if (instanceOfRdsUserProfile(userProfile) && userProfile.policyStatuses) {
          for (const policyStatus of userProfile.policyStatuses) {
            if (this._dataAccessPolicyRequirement.policyUri === policyStatus.policyUri && policyStatus.status === 'COMPLIANT') {
              if (this.accessRequirement) {
                this.facade.finalizeRequirement(this.accessRequirement.name);
                this.unsubscribe$.next();
                this.unsubscribe$.complete();
              }
            }
          }
        }
      }
    });
  }
}
